/* mix-and-match.js – stand-alone (parcel-udtræk) med popup-locking og flere valg */
(() => {
  // ----- CTA-toggle (viser korrekt knap i buybox) -----
  function bootCTA() {
    const wrappers = document.querySelectorAll('.custom-buy-box-wrapper');
    if (!wrappers.length) return;

    function showForWrapper(wrapper) {
      const selected = wrapper.querySelector('input[type="radio"]:checked');
      if (!selected) return;

      const sub  = wrapper.querySelector('.buy-box-cta-subscription');
      const sing = wrapper.querySelector('.buy-box-cta-single');
      const mm   = wrapper.querySelector('.buy-box-cta-mix-and-match');
      const box  = wrapper.querySelector('.mix-and-match');

      if (selected.classList.contains('buy-box-subscription-radio')) {
        sub?.classList.remove('d-none'); sing?.classList.add('d-none'); mm?.classList.add('d-none'); box?.classList.remove('active');
      } else if (selected.classList.contains('buy-box-single-radio')) {
        sub?.classList.add('d-none'); sing?.classList.remove('d-none'); mm?.classList.add('d-none'); box?.classList.remove('active');
      } else {
        sub?.classList.add('d-none'); sing?.classList.add('d-none'); mm?.classList.remove('d-none');
      }
    }

    wrappers.forEach(w => {
      w.querySelectorAll('.custom-buy-box').forEach(box => {
        box.addEventListener('click', (ev) => {
          setTimeout(() => showForWrapper(ev?.target?.closest('.form-product') || w), 100);
        });
      });
      showForWrapper(w);
    });
  }

  // ----- Mix & Match -----
  function initMixAndMatch() {
    const mixAndMatch       = document.querySelector('.mix-and-match');
    const mixAndMatchRadio  = document.querySelector('.mix-and-match-radio');
    const popup             = document.querySelector('.mix-and-match-popup');
    const popupBtnAddPack   = document.querySelector('.mix-and-match-popup .mix-and-match-popup-button.mix-and-match-add-package-to-cart');
    if (!mixAndMatch || !mixAndMatchRadio || !popup) return;

    const tpl = document.getElementById('mix-and-match-product-template');
    const slotsHost = document.querySelector('.mix-and-match-products');
    if (!tpl || !slotsHost) return;

    const selectedProducts = [];
    let selectedQty = null;

    // land/valuta
    const country = (popup.dataset.country || 'dk').toLowerCase();
    let currencySign = ',-';
    if (country === 'fi') currencySign = '€';
    if (country === 'se') currencySign = ':-';
    if (country === 'no' || country === 'dk') currencySign = ',-';

    // preload første valg fra radio-data
    const vId = mixAndMatchRadio.dataset.variantId;
    if (vId) {
      selectedProducts.push({
        variantId: vId,
        title:  mixAndMatchRadio.dataset.productTitle,
        image:  mixAndMatchRadio.dataset.productImage,
        form:   mixAndMatchRadio.dataset.productForm,
        amount: mixAndMatchRadio.dataset.productAmount,
        quantity: 1
      });
    }

    // klik på hele boksen klikker radio
    mixAndMatch.addEventListener('click', () => { mixAndMatchRadio?.click(); });

    // når radio vælges
    mixAndMatchRadio.addEventListener('click', () => {
      mixAndMatch.classList.add('active');
      document.getElementById('subscription-purchase')?.classList.add('subscription-purchase-toggled');
      document.getElementById('single-purchase')?.classList.add('single-purchase-toggled');
      document.querySelectorAll('.toggled_information').forEach(el => el.style.display = 'none');
      updateProgressBar();
      renderChosenProducts();
    });

    // helpers
    function closePopup() {
      try { popup.close(); } catch(_) { popup.removeAttribute('open'); }
      document.body.style.overflow = 'auto';
    }

    function updatePriceArea() {
      if (selectedQty == null) selectedQty = 1;
      let prices;
      try { prices = JSON.parse(mixAndMatch.dataset.prices || '{}'); } catch { prices = {}; }
      const current = prices[selectedQty] || prices[3];
      const parsed  = parseFloat(String(current || '').replace(currencySign, '').trim().replace(',', '.'));
      const priceEl = document.getElementById('mix-and-match-current-price');
      if (!current || !priceEl || isNaN(parsed)) return;

      const total = parsed * selectedQty;
      priceEl.textContent = country === 'fi'
        ? `${total.toFixed(2)}${currencySign}`
        : country === 'no'
          ? `kr ${total.toFixed(0)}${currencySign}`
          : `${total.toFixed(0)} ${currencySign}`;

      if (selectedQty === 0) { priceEl.classList.add('d-none'); popupBtnAddPack?.classList.add('disabled'); }
      else { priceEl.classList.remove('d-none'); popupBtnAddPack?.classList.remove('disabled'); }
    }

    function updateProgressBar() {
      selectedQty = selectedProducts.reduce((a, p) => a + (p.quantity || 0), 0);
      let step = 'data-progress-zero';
      if (selectedQty === 1) step = 'data-progress-one';
      else if (selectedQty === 2) step = 'data-progress-two';
      else if (selectedQty >= 3) step = 'data-progress-three';

      document.querySelectorAll('.mix-and-match-progress-bar > div').forEach(bar => {
        bar.classList.remove('active');
        if (bar.hasAttribute(step)) bar.classList.add('active');
      });
      updatePriceArea();
      syncPopupSelectionUI();
    }

    async function addToCart() {
      const items = selectedProducts.map(p => ({ id: Number(p.variantId), quantity: Number(p.quantity || 1) }));
      if (!items.length) return;
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ items })
      }).catch(err => console.error('[M&M] add failed', err));
    }

    // LÅS/FRIGIV kort i popuppen alt efter valg
    function syncPopupSelectionUI() {
      document.querySelectorAll('.mix-and-match-popup-product').forEach(card => {
        const qtyWrap = card.querySelector('.mix-and-match-product-quantity-selector');
        const addWrap = card.querySelector('.mix-and-match-popup-add-to-cart');
        const variantId =
          qtyWrap?.dataset?.variantId ||
          addWrap?.dataset?.variantId ||
          addWrap?.querySelector('[data-variant-id]')?.dataset?.variantId;

        const sel = selectedProducts.find(p => String(p.variantId) === String(variantId) && (p.quantity || 0) > 0);

        if (sel) {
          card.classList.add('selected');
          if (addWrap) addWrap.style.display = 'none';
          if (qtyWrap) {
            qtyWrap.style.display = 'flex';
            const input = qtyWrap.querySelector('input');
            if (input) input.value = sel.quantity || 1;
          }
        } else {
          card.classList.remove('selected');
          if (qtyWrap) {
            qtyWrap.style.display = 'none';
            const input = qtyWrap.querySelector('input');
            if (input) input.value = 1;
          }
          if (addWrap) addWrap.style.display = '';
        }
      });
    }

    function renderChosenProducts() {
      const html = tpl.innerHTML.trim();
      if (!html) return;

      const selected = selectedProducts.filter(p => (p.quantity || 0) > 0);
      slotsHost.innerHTML = '';

      for (let i = 0; i < 3; i++) {
        const product = selected[i];
        const wrap = document.createElement('div');
        wrap.innerHTML = html;

        const card   = wrap.querySelector('.mix-and-match-product');
        const imgEl  = wrap.querySelector('.mix-and-match-product-image');
        const addNext= wrap.querySelector('.mix-and-match-add-next');

        if (product?.title) {
          wrap.querySelector('.mix-and-match-product-title').textContent = product.title;
          card?.classList.remove('no-product');
        }
        if (product?.amount) {
          const qEl = wrap.querySelector('.mix-and-match-product-amount');
          if (qEl) qEl.textContent = `${product.amount} ${product.form || ''}`.trim();
        }
        if (product?.image) {
          if (imgEl) { imgEl.style.display = 'flex'; imgEl.querySelector('img').src = product.image; }
          if (addNext) addNext.style.display = 'none';
        } else {
          if (imgEl) imgEl.style.display = 'none';
          if (addNext) addNext.style.display = 'flex';
        }
        slotsHost.appendChild(wrap.firstChild);
      }

      // Åbn popup fra slots
      document.querySelectorAll('.mix-and-match-open-popup').forEach(btn => {
        btn.addEventListener('click', () => {
          try { popup.showModal(); } catch(_) { popup.setAttribute('open', ''); }
          document.body.style.overflow = 'hidden';
          syncPopupSelectionUI();
        });
      });

      syncPopupSelectionUI();
    }

    // popup close
    document.querySelectorAll('.mix-and-match-close-popup').forEach(btn => {
      btn.addEventListener('click', closePopup);
    });

    // Vælg produkt i popup (robust id)
    document.querySelectorAll('.mix-and-match-popup-add-to-cart').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const btn = e.currentTarget;
        const dataBtn = btn.dataset.variantId ? btn : btn.querySelector('[data-variant-id]');
        const id = dataBtn?.dataset?.variantId;
        if (!id) return;

        const existing = selectedProducts.find(p => String(p.variantId) === String(id));
        if (existing) {
          existing.quantity = (existing.quantity || 0) + 1;
        } else {
          selectedProducts.push({
            variantId: id,
            quantity: 1,
            title:  dataBtn.dataset.productTitle,
            image:  dataBtn.dataset.productImage,
            form:   dataBtn.dataset.productForm,
            amount: dataBtn.dataset.productAmount
          });
        }

        updateProgressBar();
        renderChosenProducts();
        syncPopupSelectionUI();
      });
    });

    // +/- mængde i popup (robust id)
    document.querySelectorAll('.mix-and-match-product-quantity-selector button').forEach(button => {
      button.addEventListener('click', () => {
        const wrap = button.closest('.mix-and-match-product-quantity-selector');
        if (!wrap) return;
        const input = wrap.querySelector('input');
        const dataWrap = wrap.dataset.variantId ? wrap : wrap.querySelector('[data-variant-id]');
        const productId = dataWrap?.dataset?.variantId;
        const idx = selectedProducts.findIndex(p => String(p.variantId) === String(productId));
        let q = parseInt(input.value || '1', 10);

        if (button.classList.contains('plus'))  { q += 1; input.value = q; if (idx >= 0) selectedProducts[idx].quantity = q; }
        if (button.classList.contains('minus')) {
          q -= 1; input.value = q;
          if (q === 0) {
            if (idx >= 0) selectedProducts.splice(idx, 1);
          } else if (idx >= 0) {
            selectedProducts[idx].quantity = q;
          }
        }
        updateProgressBar();
        renderChosenProducts();
        syncPopupSelectionUI();
      });
    });

    // læg pakken i kurv
    document.querySelectorAll('.mix-and-match-add-package-to-cart').forEach(button => {
      button.addEventListener('click', async () => {
        await addToCart();
        document.dispatchEvent(new Event('cart:updated', { bubbles: true }));
        closePopup();
      });
    });
  }

  // ----- Boot -----
  function boot() {
    try { initMixAndMatch(); } catch(e) { console.error('[M&M] init error', e); }
    try { bootCTA(); } catch(e) { console.error('[M&M] cta error', e); }
  }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('drawerProduct:updated', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);

  // eksponér til manuel test
  window.initMixAndMatch = initMixAndMatch;
})();
